'use client'

import { useState, useEffect } from 'react'
import dynamic from 'next/dynamic'

// ssr: false must live in a Client Component — Server Components cannot suppress SSR for individual imports.
const HeroBackground = dynamic(
  () => import('@/components/marketing/HeroBackgroundDynamic'),
  { ssr: false, loading: () => null },
)

export function HeroBackgroundWrapper() {
  const [ready, setReady] = useState(false)

  useEffect(() => {
    // Defer canvas mount to idle — prevents canvas DOM insertion from triggering
    // a LCP re-record for the H1 span that sits in the same stacking context.
    const go = () => setReady(true)
    if ('requestIdleCallback' in window) {
      requestIdleCallback(go, { timeout: 2000 })
    } else {
      setTimeout(go, 200)
    }
  }, [])

  return ready ? <HeroBackground /> : null
}
